import { Action, AnyAction, combineReducers, Dispatch, Middleware, ThunkAction, ThunkDispatch } from "@reduxjs/toolkit";
import { entityReducer } from "./entity/entityReducer";
import { otsBaseApi } from "./ots-api";

export type LoadingState = 'idle' | 'pending';

export type KeyObject<T = string[] | undefined> = {
  [key: string]: T;
};

export type OtsThunk<R = void> = ThunkAction<
  R,
  OtsState,
  OtsAsyncThunkConfigExtra<OtsState>,
  Action<string>
>;

export type OtsThunkDispatch = ThunkDispatch<
  OtsState,
  OtsAsyncThunkConfigExtra<OtsState>,
  Action<string>
>;

export type OtsAsyncThunkConfigExtra<S extends OtsState = OtsState> = {
  getAuthToken: (state: S) => string | undefined;
  getRegionId: (state: S) => string | undefined;
  baseUrl: string;
  clientApp: string
  tenantCode: string | undefined
};

export type OtsAsyncThunkConfig = {
  state: OtsState;
  dispatch: OtsDispatch;
  extra: OtsAsyncThunkConfigExtra<OtsState>;
  rejectValue: string;
};

export const apis = [
  otsBaseApi,
];

export const apiReducers = apis.reduce(
  (curr, api) => ({
    ...curr,
    [api.reducerPath]: api.reducer,
  }),
  {}
);

export const otsMiddleware: Middleware[] = apis.map((api) => api.middleware);

export const otsReducers = {
  ...apiReducers,
  entities: entityReducer,
};

export const otsReducer = combineReducers(otsReducers);

export type OtsState = ReturnType<typeof otsReducer>;

export type OtsDispatch =
  | Dispatch<any>
  | (ThunkDispatch<OtsState, OtsAsyncThunkConfigExtra<OtsState>, AnyAction> &
      Dispatch<any>);
